import React, { FC, useState } from 'react';

import Image from 'next/image';

import cn from 'classnames';

import Arrow from '@/assets/question-arrow-down.svg';

import styles from './Question.module.scss';

type Props = {
	question: string;
	answer?: string;
	node?: React.ReactNode;
	isFirst?: boolean;
};

export const Question: FC<Props> = ({ question, answer, node, isFirst }) => {
	const [isOpen, setIsOpen] = useState(isFirst);

	const handleOpen = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div className={styles.container}>
			<div className={styles.title} onClick={handleOpen}>
				<Image
					className={cn(styles.arrow, {
						[styles.rotate]: !isOpen,
					})}
					src={Arrow}
					width={24}
					height={24}
					alt=""
				/>
				<div className={styles.questionTitle}>{question}</div>
			</div>
			{isOpen && (
				<div>
					{answer && <div className={styles.answer}>{answer}</div>}
					{node && <div className={styles.answer}>{node}</div>}
				</div>
			)}
		</div>
	);
};
